import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  message,
  Space,
  Select,
  DatePicker,
  Descriptions,
} from 'antd';
import styled from 'styled-components';
import dayjs from 'dayjs';
import PersistentDrawerLeft from "../../../components/reusable/admin/Main";
import { restApi } from "../../../constants/api";

const { Title } = Typography;
const { Option } = Select;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f9f9f9;
`;

const StyledCard = styled(Card)`
  max-width: 700px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-radius: 16px;
`;

const StyledButton = styled(Button)`
  background-color: #1677ff;
  border-radius: 8px;
  width: 100%;
  height: 40px;
  font-weight: 500;
  font-size: 16px;

  &:hover {
    background-color: #0056d2;
  }
`;

const StartAttendanceCycle = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  // const [departments, setDepartments] = useState([]);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [messageText, setMessagetext] = useState<string>(' ');

  // Fetch users & departments
  useEffect(() => {
    restApi('/api/users/dropdown', 'GET').then((res: any) => {
      setUsers(res?.data || []);
    });
    // restApi('/api/departments', 'GET').then((res: any) => {
    //   setDepartments(res?.data || []);
    // });
  }, []);

  const handleUserChange = (value: string) => {
    const user: any = users.find((u: any) => u.id === value);
    setSelectedUser(user);
    form.setFieldValue("userId", value);
    form.setFieldValue("totalDays", user?.total_number_of_days);
    if (form.getFieldValue("start_date")) {
      const start = form.getFieldValue("start_date");
      calculateEndDate(start, user?.total_number_of_days);
    }
  };

  const handleStartDateChange = (date: any) => {
    const days = selectedUser?.total_number_of_days;
    if (date && days) {
      calculateEndDate(date, days);
    }
  };

  const calculateEndDate = (startDate: any, days: number) => {
    const end = dayjs(startDate).add(days, 'day');
    setEndDate(end.format("YYYY-MM-DD"));
  };

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const payload = {
        userId: values.userId,
        // departmentId: values.departmentId,
        start_date: values.start_date.format("YYYY-MM-DD"),
        end_date: endDate
      };
      await restApi('/api/users/cycles/start', 'POST', payload);
      message.success("Attendance cycle started!");
      form.resetFields();
      setSelectedUser(null);
      setEndDate(null);
      // setLoading(false);
      navigate('/admin/users/cycles'); // or wherever
    }
    catch (error: any) {
      const e = error?.response?.data?.message || "This user already has an active attendance cycle. Please end it before starting a new one.";
      message.error(e);
      setMessagetext(e);
    } finally {
      setLoading(false); // ✅ Always runs
    }
  };

  return (
    <PersistentDrawerLeft>
      <StyledContainer>
        <StyledCard>
          <Title level={3} style={{ textAlign: 'center', marginBottom: 30 }}>
            Start New Attendance Cycle
          </Title>

          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              label="Select User"
              name="userId"
              rules={[{ required: true, message: 'Please select a user' }]}
            >
              <Select placeholder="Select a user" onChange={handleUserChange}>
                {users.map((u: any) => (
                  <Option key={u.id} value={u.id}>
                    {u.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {selectedUser && (
              <Descriptions column={1} bordered size="small" style={{ marginBottom: 20 }}>
                <Descriptions.Item label="Name">{selectedUser.name}</Descriptions.Item>
                <Descriptions.Item label="Email">{selectedUser.email}</Descriptions.Item>
                <Descriptions.Item label="Mobile">{selectedUser.mobileNo}</Descriptions.Item>
                <Descriptions.Item label="Department">{selectedUser.department_name}</Descriptions.Item>
                <Descriptions.Item label="Designation">{selectedUser.user_type}</Descriptions.Item>
                <Descriptions.Item label="Total Days">{selectedUser.total_number_of_days}</Descriptions.Item>
              </Descriptions>
            )}

            {/* <Form.Item
              label="Select Department"
              name="departmentId"
              rules={[{ required: true, message: 'Please select a department' }]}
            >
              <Select placeholder="Select a department">
                {departments.map((d: any) => (
                  <Option key={d.id} value={d.id}>
                    {d.name}
                  </Option>
                ))}
              </Select>
            </Form.Item> */}

            <Form.Item
              label="Start Date"
              name="start_date"
              rules={[{ required: true, message: 'Please select a start date' }]}
            >
              <DatePicker style={{ width: '100%' }} onChange={handleStartDateChange} />
            </Form.Item>

            {endDate && (
              <Form.Item label="Calculated End Date">
                <Input value={endDate} readOnly />
              </Form.Item>
            )}

            <Form.Item>
              <Space>
                <StyledButton type="primary" htmlType="submit" loading={loading} disabled={loading}>
                  {/* Start Cycle */}
                  {loading ? "Starting..." : "Start Cycle"}
                </StyledButton>
                <Button onClick={() => navigate(-1)}>Cancel</Button>
              </Space>
              <br />
              <br />
              <span style={{color:"red", fontSize:"18px"}}>{messageText}</span>
            </Form.Item>
          </Form>
        </StyledCard>
      </StyledContainer>
    </PersistentDrawerLeft>
  );
};

export default StartAttendanceCycle;
